import React from 'react';

export { default } from './Table';

export const Hidden = ({ children }) => (
  <div className="table__hidden">
    {children}
  </div>
);